import React from 'react'
import styled from 'styled-components'
import formatNumber from '../../../helpers/formatNumber'

const Cell = styled.span`
  text-align: right;
`

export default (props) => {
  const { data } = props
  let content
  if (typeof parseInt(data, 10) === 'number'&& !Number.isNaN(parseInt(data, 10))) {
    content = formatNumber(data)
  } else if (typeof data === 'string') {
    content = data
  } else {
    content = '-'
  }
  return <Cell>{content}</Cell>
}